import { Col, ConfigProvider, Flex, Row, Space, Table } from "antd";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useTranslation } from "react-i18next";

function EmployeeSalaryTaxDetail({
    taxColumn = [],
    stepTaxData = []
}) {
    const { t } = useTranslation();

    const getSummaryTotals = (data) => {
        let totalNetIncomeLevel = 0;
        let totalNetIncomeAtLevel = 0;
        let totalTaxRate = 0;
        let totalIncomeTax = 0;

        data?.forEach(({ netIncomeLevel, netIncomeAtLevel, taxRate, incomeTax }) => {
            totalNetIncomeLevel += parseFloat(netIncomeLevel) || 0;
            totalNetIncomeAtLevel += parseFloat(netIncomeAtLevel) || 0;
            totalTaxRate += parseFloat(taxRate) || 0;
            totalIncomeTax += parseFloat(incomeTax) || 0;
        });

        return {
            totalNetIncomeLevel,
            totalNetIncomeAtLevel,
            totalTaxRate,
            totalIncomeTax,
        };
    };

    const totals = getSummaryTotals(stepTaxData?.stepTax);

    const netWithholdingTax = (totals?.totalIncomeTax != null && stepTaxData?.witholdingTax?.numberOfPaymentPeriodsInYear != null)
        ? totals?.totalIncomeTax / stepTaxData?.witholdingTax?.numberOfPaymentPeriodsInYear
        : 0;

    return (
        <Space direction="vertical" size={24} style={{ width: "100%", height: "60vh", overflowY: "auto" }}>
            <ConfigProvider
                theme={{
                    components: {
                        Table: {
                            headerBg: "none",
                            borderColor: "none",
                            headerSplitColor: "none"
                        },
                    },
                }}
            >
                {stepTaxData?.stepTax?.length > 0 ?
                    <Table columns={taxColumn} dataSource={stepTaxData?.stepTax} pagination={false} summary={() => {
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0}>
                                    {/* <span style={{ display: "flex", justifyContent: "flex-end" }}>{get2DecimalPointsWithCommas(totals?.totalNetIncomeLevel)} {t('unit.baht')}</span> */}
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    <span style={{ display: "flex", justifyContent: "flex-end", fontWeight: "bold" }}>{get2DecimalPointsWithCommas(totals?.totalNetIncomeAtLevel)} {t('unit.baht')}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>
                                    {/* <span style={{ display: "flex", justifyContent: "flex-end" }}>{get2DecimalPointsWithCommas(totals?.totalTaxRate)}</span> */}
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>
                                    <span style={{ display: "flex", justifyContent: "flex-end", fontWeight: "bold" }}>{get2DecimalPointsWithCommas(totals?.totalIncomeTax)} {t('unit.baht')}</span>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        )
                    }} /> : null
                }
            </ConfigProvider>
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>{t("salary.label.withholdingTax")}</span>
            <Flex vertical>
                <Row>
                    <Col span={12}><span style={{ fontWeight: "bold" }}>{t("salary.label.incomeTaxDeduction")}  {"(" + (stepTaxData?.witholdingTax?.taxRate || 0) + " %" + ")"}</span></Col>
                    <Col span={6} style={{ textAlign: "right", padding: "0px 16px" }}><span style={{ fontWeight: "bold" }}>(1) =</span></Col>
                    <Col span={6} style={{ textAlign: "right", padding: "0px 16px" }}><span style={{ fontWeight: "bold" }}>{get2DecimalPointsWithCommas(stepTaxData?.witholdingTax?.incomeTaxDeduction)} {t('unit.baht')}</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span style={{ fontWeight: "bold" }}>{t("salary.label.taxPaid")}</span></Col>
                    <Col span={6} style={{ textAlign: "right", padding: "0px 16px" }}><span style={{ fontWeight: "bold" }}>(2) =</span></Col>
                    <Col span={6} style={{ textAlign: "right", padding: "0px 16px" }}><span style={{ fontWeight: "bold" }}>{get2DecimalPointsWithCommas(stepTaxData?.witholdingTax?.taxPaid)} {t('unit.baht')}</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span style={{ fontWeight: "bold" }}>{t("salary.label.numberOfPeriod")}</span></Col>
                    <Col span={6} style={{ textAlign: "right", padding: "0px 16px" }}><span style={{ fontWeight: "bold" }}>(3) =</span></Col>
                    <Col span={6} style={{ textAlign: "right", padding: "0px 16px" }}><span style={{ fontWeight: "bold" }}>{stepTaxData?.witholdingTax?.numberOfPaymentPeriodsInYear ? stepTaxData?.witholdingTax?.numberOfPaymentPeriodsInYear : "0"} {t('unit.periods')}</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span style={{ fontWeight: "bold" }}>{t("salary.label.Net withholding tax")}</span></Col>
                    <Col span={6} style={{ textAlign: "right", padding: "0px 16px" }}><span style={{ fontWeight: "bold" }}>[(1) - (2)] / (3) =</span></Col>
                    <Col span={6} style={{ textAlign: "right", padding: "0px 16px" }}><span style={{ fontWeight: "bold" }}>{get2DecimalPointsWithCommas(stepTaxData?.witholdingTax?.netWithholdingTax)} {t('unit.baht')}</span></Col>
                </Row>

            </Flex>
        </Space>
    )
}

export default EmployeeSalaryTaxDetail;